/**
 * Tags a reader may pick for themselves. Authority tags ("Verified reviewer",
 * "Adopted as a standard") are reserved for curated/seeded reviews.
 */
export const SELF_SERVE_REVIEW_TAGS = ["Reader", "Practitioner", "Community"] as const;
